import { Component, Directive, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from './data-table.directive';
import { Base } from '../models/base.model';
import { ColumnConfig } from '../models/column-config.model';
import { ApiService } from '../services/api.service';
import { TitleService } from '../services/title.service';
import { NotificationService } from '../services/notification.service';
import { PageStateManagerService } from '../services/page-state-manager.service';
import { AuthService } from '../services/auth.service';

@Directive()
export abstract class ChildDataTableDirective<T extends Base> extends DataTableDirective<T>  {
  
  parentID: number | null = null;  

  constructor(
    apiService: ApiService<T>,
    fb: FormBuilder,
    route: ActivatedRoute, 
    router: Router,
    titleService: TitleService,
    notificationService: NotificationService,
    pageStateManager: PageStateManagerService,
    authService: AuthService,
  ) {
    super(
      apiService, 
      fb, 
      route, 
      router, 
      titleService, 
      notificationService,
      pageStateManager,
      authService
    );
  }

  abstract onGoBack(): void;

  
}
